<template lang="pug">
div.tw-flex.tw-gap-4.tw-items-center(class="emd:tw-w-full emd:tw-justify-between emd:tw-gap-0")
	v-btn(
		:rounded="0"
		variant="outlined"
		prepend-icon='mdi-arrow-left'
		color='accent'
		:density="isMobile ? 'comfortable' : 'default'"
		@click.stop="goBack"
	) {{btnText}}
	div(class="tw-text-[#cdcdcd]" v-if="!isMobile && bookingStore.selectedTotalPrice > 0" ) |
	div.tw-font-bold.tw-text-xl(v-if="bookingStore.selectedTotalPrice > 0" ) {{formattedPrice}}
</template>

<script setup>
import { useBookingStore } from '@/stores/booking';
import { useBookingStepperStore } from '@/stores/booking-stepper';


const bookingStore = useBookingStore();
const props = defineProps({
	btnText: {
		type: String,
		default: ''
	},
	formattedPrice: {
		type: String,
		default: null
	},
	isMobile: {
		type: Boolean,
		default: false
	}
});
const stepper = useBookingStepperStore();


function goBack() {
	stepper.goBack();
	bookingStore.setEvaluatedSolution();
}
</script>